import {
	Vue, Component, Watch, Prop, toNative,
} from 'vue-facing-decorator';
import { h } from 'vue';
import * as DB from 'interfaces/database';
import { PickerOptions, PickerResponse } from 'filestack-js';
import CustomCheckbox from 'components/CustomCheckbox';
import CustomFileInput from 'components/CustomFileInput';
import OfferingService from 'services/OfferingService';
import OfferingFrameService from 'services/OfferingFrameService';
import Template from './template.vue';

@Component({
	mixins: [Template],
	components: {
		CustomCheckbox,
		CustomFileInput,
	},
})
class Frame extends Vue {
	@Prop({
		type: String,
		required: true,
	})
	public readonly routeId!: string;

	private imagePreview = '';

	private frame = {} as DB.OfferingFrameModel;

	private frameDataExist = false;

	private placeHolders = {
		thumbnailPlaceholder: 'No file chosen',
	};

	private isHidden = false;

	private isLoading = false;

	private spinner = false;

	protected mounted(): void {
		this.getFrameData();
	}

	// getter for authenticated user
	private get loggedIn(): boolean {
		return this.$auth0.isAuthenticated.value;
	}

	@Watch('loggedIn')
	private async getFrameData(): Promise<void> {
		if (this.loggedIn) {
			this.spinner = true;
			try {
				const response = await OfferingService.getOfferingFrame(this.routeId);
				this.frame = response;
				this.imagePreview = response.url;
				if (Object.keys(this.frame).length !== 0) {
					this.isHidden = true;
					this.frameDataExist = true;
				}
			} catch (error: any) {
				this.$toastError(error.message);
			} finally {
				this.spinner = false;
			}
		}
	}

	private addFrameData(): void {
		if (this.loggedIn) {
			this.isLoading = true;
			// Add  Frame Data
			OfferingFrameService.create(
				{
					...this.frame,
					url: this.imagePreview,
					offeringid: parseInt(
						this.routeId,
						10,
					),
				},
			)
				.then((res) => {
				// Custom toast with spinner
					this.frame = res;
					setTimeout(
						() => {
							this.$bvToast.toast(
								h(
									'p',
									{ class: ['text-center', 'mb-0'] },
									[
										h(
											'b-spinner',
											{ props: { type: 'grow', small: true } },
										),
										h(
											'strong',
											'Frame Added Successfully',
										),
										h(
											'b-spinner',
											{ props: { type: 'grow', small: true } },
										),
									],
								),
								{
									solid: true,
									variant: 'success',
								},
							);
						},
						2000,
					);
					return undefined;
				})
				.finally(() => {
					this.isLoading = false;
				})
				.catch((err) => {
					this.$toastError(err.message);
				});
		}
	}

	private editFrameData(): void {
		if (this.loggedIn) {
			this.isLoading = true;
			// Add  Frame Data
			OfferingFrameService.update(
				this.frame.id,
				{
					...this.frame,
					url: this.imagePreview,
					offeringid: parseInt(
						this.routeId,
						10,
					),

				},
			)
				.then((res) => {
				// Custom toast with spinner
					this.frame = res;
					setTimeout(
						() => {
							this.$bvToast.toast(
								h(
									'p',
									{ class: ['text-center', 'mb-0'] },
									[
										h(
											'b-spinner',
											{ props: { type: 'grow', small: true } },
										),
										h(
											'strong',
											'Frame Added Successfully',
										),
										h(
											'b-spinner',
											{ props: { type: 'grow', small: true } },
										),
									],
								),
								{
									solid: true,
									variant: 'success',
								},
							);
						},
						2000,
					);
					return undefined;
				})
				.finally(() => {
					this.isLoading = false;
				})
				.catch((err) => {
					this.$toastError(err.message);
				});
		}
	}

	protected handleClick(): void {
		if (this.frameDataExist) {
			this.editFrameData();
		} else {
			this.addFrameData();
		}
	}

	protected async updateImage(): Promise<void> {
		const options: PickerOptions = {
			fromSources: ['local_file_system'],
			onUploadDone: async (files: PickerResponse) => {
				this.imagePreview = files.filesUploaded[0].url;
				this.placeHolders.thumbnailPlaceholder = files.filesUploaded[0].filename;
			},
		};
		this.$client.picker(options).open();
	}

	protected removeImage(): void {
		this.imagePreview = '';
		this.placeHolders.thumbnailPlaceholder = '';
	}
}

export default toNative(Frame);
